<template>
  <main>
    <b-row class="m-0">
      <b-col
        lg="5"
        class="pl-0"
      >
        <h2 v-html="$t('meta.title')"></h2>
      </b-col>
      <b-col
        class="alert alert-info"
        lg="7"
        v-html="$t('rules', { n: result })"
      />
    </b-row>
    <b-row class="m-0">
      <div
        v-for="index in Object.keys($t('tiles')).length"
        :key="index"
        :class="`tile text-center ${tiles[index-1] ? 'checked' : ''}`"
      >
        <div class="text-left">
          <input
            :id="`tile_${index}`"
            v-model="tiles[index-1]"
            type="checkbox"
            @change="bingoCount()"
          />
        </div>
        <label :for="`tile_${index}`">
          <p
            class="title"
            v-html="$t(`tiles.t${index}[0]`)"
          ></p>
          <p
            class="desc"
            v-html="$t(`tiles.t${index}[1]`)"
          ></p>
        </label>
      </div>
    </b-row>
    <h3
      class="mt-4"
      v-html="$t('share')"
    ></h3>
    <input
      v-model="share"
      class="form-control"
      value
      readonly
      type="text"
    />
    <div class="hidden">
      <audio
        ref="troll"
        :src="`${$t('/')}media/troll.wav`"
      ></audio>
      <audio
        ref="tadaa"
        :src="`${$t('/')}media/tadaa.wav`"
      ></audio>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      numbers: [],
      share: this.$t('url'),
      count: 0,
      result: '<b class="text-warning">0</b>',
      tiles: [...Array(Object.keys(this.$t('tiles')).length).keys()].map(i => !(i + 1)),
      bingos: [['1', '2', '3', '4', '5'],
        ['6', '7', '8', '9', '10'],
        ['11', '12', '13', '14', '15'],
        ['16', '17', '18', '19', '20'],
        ['21', '22', '23', '24', '25'],
        ['1', '6', '11', '16', '21'],
        ['2', '7', '12', '17', '22'],
        ['3', '8', '13', '18', '23'],
        ['4', '9', '14', '19', '24'],
        ['5', '10', '15', '20', '25'],
        ['1', '7', '13', '19', '25'],
        ['5', '9', '13', '17', '21']],
    };
  },
  mounted() {
    if (this.$t('hash')) {
      this.numbers = this.$t('hash').replace('#', '').split('-');
      this.numbers.forEach((n) => {
        this.tiles[n - 1] = true;
      });
      this.bingoCount();
    }
  },
  methods: {
    bingoCount() {
      /* Numbers list update */
      this.numbers = [];
      this.tiles.forEach((n, i) => {
        if (n) {
          this.numbers.push(`${i + 1}`);
        }
      });

      /* Results */
      const currentCount = this.count;
      this.count = this.numbers.length;
      for (let i = 0; i < this.bingos.length; i += 1) { // line, column, diagonal
        if ((this.numbers.indexOf(this.bingos[i][0]) > -1)
          && (this.numbers.indexOf(this.bingos[i][1]) > -1)
          && (this.numbers.indexOf(this.bingos[i][2]) > -1)
          && (this.numbers.indexOf(this.bingos[i][3]) > -1)
          && (this.numbers.indexOf(this.bingos[i][4]) > -1)) {
          this.count += 5;
        }
      }
      this.result = `<b class="text-warning">${this.count}</b>`;

      /* Sound */
      if (this.count === 85) {
        this.$refs.tadaa.play();
      } else if (currentCount < this.count) {
        this.$refs.troll.play();
      }

      /* Share link update */
      this.share = `${this.$t('baseurl')}#${this.numbers.join('-')}`;
      window.location.href = `#${this.numbers.join('-')}`;
    },
  },
};
</script>

<style lang="scss">
main {
  font-family: "Lavi", serif;
  padding-bottom: 25px;

  h2 {
    font-family: "Lavi", serif;

    &::after {
      content: none !important;
    }
  }

  label {
    font-weight:normal;
  }

  .tile {
    width: 216px;
    height: 170px;
    float: left;
    position: relative;
    background-color: var(--f-g1);
    border: 1px solid var(--f-g6);
    padding:5px;

    &:hover {
      background-color: var(--f-b2);
    }

    &.checked {
      background-color: var(--f-g1);
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="134" height="108.545" fill="%23b4aac3"><g clip-rule="evenodd" fill-rule="evenodd"><path d="M65.438 14.009c1.984 1.616 3.575 3.628 3.601 7.204 1.436-2.878-.284-6.909-3.601-7.204zM89.571 18.33c-2.975-1.606-3.868 5.678-2.161 7.565-.235-3.476-.053-6.536 2.161-7.564zM37.701 30.218c2.497 2.877 5.917.413 9.366 0 7.44-.891 14.583 2.421 19.811 4.683 11.757-5.98-3.12-14.245-14.769-13.688-7.902.377-13.223 3.908-14.408 9.005zm20.172-6.124c3.641 2.002 9.565 1.722 9.726 7.204-5.105.302-6.125-3.48-11.167-3.241.493-1.308.218-3.385 1.44-3.963zm-16.57 4.683c.379-1.663 1.74-2.343 3.962-2.161.215 2.256-2.819 1.263-3.962 2.161zM85.249 30.218c-1.727-.403-3.306-1.008-4.683 0 .11 2.652 3.045 2.477 4.683 3.602v6.844c2.028 1.814 5.004 2.68 6.483 5.043-1.209 3.113-3.35 5.294-6.123 6.844-1.786-.101-2.44-2.139-4.323-1.081 2.63 8.723 9.802.28 12.608-3.242.976.465 1.28 1.601 2.882 1.44-.173-1.132.512-1.407.72-2.16 2.817.665 3.98 2.983 7.564 2.881-6.53-2.954-11.245-7.725-16.93-11.526V33.82c4.708-3.457 14.85-1.481 20.172-4.323-3.207-8.463-19.327-4.69-23.053.72zm18.01-2.161c-1.764.693-4.63.315-6.124-.36 1.765-.694 4.63-.316 6.124.36zM36.26 27.696c-1.524-.673-3.73 1.066-6.123.72-.007 1.918 3.145 2.228 4.683 1.442-.05-1.032-2.473.31-2.522-.72 1.252-.55 3.022-.58 3.963-1.442zM109.743 29.137c8.93-.701 18.795 2.88 19.09 11.527.043 1.253-.02 4.049-1.08 5.763-1.68 2.72-5.92 1.374-7.204 5.043 6.632-1.592 9.68-5.347 9.005-11.887-.937-9.079-9.809-12.485-19.811-10.446zM8.165 35.621c2.508-4.815 7.931-6.716 15.849-6.124-6.155-1.403-14.783.128-15.85 6.124zM36.26 31.298c-.48-1.024-1.601.279-2.16.361.501 1.046 1.777-.102 2.16-.36z"/><path d="M52.83 31.66c-3.774.613-5.536 4.629-10.086 5.042-5.564.505-8.463-3.407-13.328-4.683-13.237-3.474-23.97 8.855-14.048 19.451 1.6-3.573-1.574-5.369-1.08-9.726.575-5.073 5.448-8.466 11.166-7.564 1.924.304 3.615 2.38 5.763 3.242 7.743 3.108 21.466 2.872 21.613-5.763zM119.828 32.38c1.232 2.253 6.52 3.564 4.683 10.085 1.824-1.606-.115-4.98.36-7.564-1.739-.782-3.348-1.695-5.043-2.522zM104.7 39.223c-1.593-.448-1.965-2.118-4.323-1.8-1.522 4.68 4.534 4.804 9.005 4.682.386-1.776 1.135-3.188 2.522-3.962 4.125-.403 6.572.871 10.085 1.08-1.893-7.434-13.956-3.463-17.29 0z"/><path d="M16.45 46.788c1.918.701 3.434-.148 5.402-.361 1.271 1 2.357 3.324 1.441 5.403 4.603 3.949 7.662 11.209 12.247 16.21 11.318 12.346 31.007 17.692 56.553 16.57 8.261-.364 17.881-1.263 21.972-5.404 6.482-6.56 6.79-26.896 1.081-34.94-.554-1.127.157-3.52-1.08-3.962-2.877.99-1.308 5.183-2.162 7.564-1.78 4.961-11.703 8.16-18.73 9.005C66.82 60.04 44.56 46.234 27.254 40.303c-.518-1.283-.367-3.234-1.44-3.961-2.152.75-1.27 2.555-2.162 3.962-1.974 3.118-6.702 3.346-7.204 6.484zm21.972 2.16v5.404c-6.761-1.164-12.605-3.244-12.968-10.806 5.94.182 8.196 4.051 12.968 5.403zm76.724 3.963c-.884-.1-1.66-2.15-1.08-2.522.298.902.986 1.415 1.08 2.522zm-56.913 2.162c.014 2.415-.924 3.878-1.08 6.123-6.077-2.689-15.318-2.213-15.85-10.446 5.369.276 11.158 3.25 16.93 4.323zm53.31 6.843c-.34-2.667-1.948-6.222-.36-8.645 1.18 1.765 4.106 7.436.36 8.645zm-73.481 2.882c-.916-.767-2.211-1.338-3.242-2.522-1.388-1.593-4.158-6.476-3.603-6.484 4.177.702 10.176 4.27 6.845 9.006zm69.52-1.441c-1.77-.552-3.14 1.16-3.963.36 1.293-2.144-1.262-3.532-1.08-5.763 2.118-.042 3.032-1.29 4.682-1.8 1.959 1.569.567 4.75.36 7.203zm-45.747-6.844c4.335 1.068 9.105 1.702 13.328 2.882v5.403c-6.212.45-10.366-1.16-15.129-2.161.407-2.235.4-4.883 1.801-6.124zm39.263 7.204c-3.096.867-6.65 1.275-10.806 1.081.237-1.726-.37-3.96 0-4.683 3.25-.35 6.991-.212 9.365-1.44.48 1.68.558 3.764 1.44 5.042zm-14.409-3.602c-.086 1.888.877 2.725 1.081 4.323-2.676.806-6.82.145-10.086.36v-5.403c3.41-.168 5.41 1.074 9.005.72zM55.712 66.24c.509 4.591-2.323 5.841-2.882 9.365-5.092-1.992-8.774-5.394-12.968-8.284 2.05-.954 1.88-4.125 2.522-6.484 3.855 2.388 8.336 4.15 13.328 5.403zm16.57 4.682c.28 3.522-.509 5.976-.36 9.365-6.947.463-11.3-1.668-16.21-3.241.87-3.573 3.137-5.748 3.242-10.086 3.911 1.852 8.032 3.494 13.327 3.962zm39.622 5.043c.054-2.828 1.474-4.29 2.882-5.763-.618 2.263-1.445 4.319-2.882 5.763zm-6.844 3.242c.822-3.02 1.671-6.013 4.322-7.204.21 2.01-1.076 2.526-1.08 4.322.223 1.24 1.937.73 2.161 1.081-1.27 1.13-3.382 1.42-5.403 1.801zm-19.091-6.123c-.022 3.1-1.198 5.046-1.08 8.284-3.36-.122-7.28.315-10.086-.36.11-1.644.597-5.833.36-9.005 3.268.715 7.45 1.545 10.806 1.08zm15.85 6.483c-1.39.532-2.722 1.12-4.684 1.081.482-2.4 2.086-3.677 2.162-6.484 1.898-.023 2.643-1.198 4.683-1.08-.335 2.465-3.215 3.77-2.162 6.483zm-5.404-5.763c-.652 2.71-2.276 4.449-2.882 7.204-1.703.109-4.589.922-6.123 0 .336-4.927 3.086-9.023 9.005-7.204z"/><path d="M61.115 44.266c-.378 4.495.578 9.054 5.043 7.564.48-3.133-3.248-2.971-2.522-5.403.679-2.27 3.72-1.023 6.484-2.161-.64-4.332-7.506-2.036-9.005 0zM60.034 42.105c-1.518-.062-.247.806 0 1.08-1.3 4.048-9.196-.72-10.806 2.882 3.217-2.223 12.47 1.95 10.806-3.962zM125.232 42.825c-1.428 1.213-2.474 2.81-4.323 3.602 2.178.97 4.15-1.367 4.323-3.602z"/><path d="M67.599 47.508c.073 1.127-.243 2.644.36 3.242 2.297-1.826 6.468.064 9.725-1.081-.39-3.898-6.983-3.04-10.085-2.161zM37.701 77.405c-.465.845 2.551 1.167 3.962 1.801 10.469 4.7 21.805 13.19 37.462 11.887-17.812-.558-27.095-9.646-41.424-13.688zM112.264 84.61c-3.607 4.917-10.749 6.3-18.73 6.843 7.66.576 17.388.1 18.73-6.844zM75.163 87.131c5.142.238 13.04 1.381 18.73.36-.317.057 2.053.394.72-.36-6.718.31-13.675-.503-19.45 0zM88.13 91.453c-1.328-.833-4.197-.125-6.123-.36 1.328.833 4.197.125 6.123.36z"/><path d="M122.71 14.009C105.542-2.335 72.408-.06 40.583.32c-3.027.036-6.448-.528-9.005 0-4.579.945-9.729 6.565-12.247 10.806-1.869 3.145-2.726 7.72-4.323 10.446C9.961 30.192-2.917 32.337.6 47.508c1.635 7.054 9.138 9.91 12.967 16.93 1.38 2.53 1.637 5.382 2.882 7.564 4.792 8.398 17.266 14.663 27.736 19.451 7.958 3.64 16.705 9.13 24.134 11.167 4.896 1.343 12.168 2.473 19.451 3.962 10.455 2.138 22.34 3.195 30.618-.36 4.299-1.847 9.169-6.282 10.086-10.447 2.151-9.768-4.282-26.207-1.441-37.821 1.95-7.972 8.834-13.47 6.484-23.414-1.994-8.432-11.748-8.022-10.807-20.531zM3.842 47.869c-4.015-11.115 5.438-20.67 18.37-20.173-2.387-.813-4.951-.013-7.563 0 6.258-7.681 7.774-23.51 20.892-24.854 18.145-1.858 41.744.564 59.073 2.162-12.076 3.164-25.112-2.265-37.822-1.081C45.064 5.016 36.834 12.15 30.497 17.61c7.422-4.147 15.168-11.897 26.656-12.968 9.551-.89 16.305 1.708 24.494 2.162 6.562.363 13.38-1.31 19.09-.72 6.708.692 18.13 6.419 19.812 11.526.612 1.86-.055 4.145.72 6.124 2.754 7.03 12.483 8.978 9.005 20.892-.968 3.316-3.583 5.227-4.682 7.564-3.237 6.883-1.933 17.973-1.081 26.295.533 5.2 2.066 11.211 1.08 16.21-2.639 13.377-28.326 11.363-40.703 8.284-4.423-1.1-8.326-3.165-11.887-3.602-1.565-.192-3.256.458-5.763 0-3.53-.645-8.467-4.395-12.607-6.484C42.34 86.697 25.7 81.192 18.97 70.561c-1.72-2.717-2.368-7.124-3.602-9.365-.867-1.574-3.244-1.888-2.882-3.962-.154.58 1.343 1.209 1.44.36-4.378-1.956-8.681-5.84-10.084-9.726z"/><path d="M107.581 11.487c-2.87-5.07-11.56-1.148-18.37-1.08-10.053.099-19.954-3.14-29.177-2.522-11.112.745-21.198 6.031-26.655 12.607C40.54 14.9 50.846 8.53 64.717 8.605c7.348.04 14.88 2.945 24.494 2.522 7.235-.318 13.731-2.82 18.37.36z"/><path d="M66.878 12.928c.891.046.613-.441 0-.36-12.36-1.099-24.639.746-28.816 9.005 5.447-7.04 15.9-9.073 28.816-8.645zM85.609 16.17c6.803-2.242 20.886-3.192 23.053 5.043 1.027-5.016-7.036-7.868-14.768-7.565-3.103.122-7.245.416-8.285 2.522zM15.729 54.712c-7.35-1.217-8.847-10.067-7.564-18.73-2.249 5.088-.196 10.261.36 15.488 2.246 1.236 3.68 3.284 7.204 3.242zM119.108 85.69c-.821.5-.134 2.507-.36 3.602-13.728 11.433-45.166 4.948-61.235-.36-9.978-3.297-18.506-8.944-27.736-11.527 15.017 10.316 47.92 20.69 75.283 18.73 6.404-.458 15.453-2.95 14.048-10.445z"/></g></svg>');
      background-position: center;
      background-repeat: no-repeat;
    }

    input {
      position: absolute;
      left: 7px;
      top: 7px;
    }
  }

  .title {
    min-height: 45px;
    text-transform: uppercase;
    max-width: 75%;
    margin: 0 auto 10px;
  }
}
</style>
